import React, { useState } from 'react'
import { Link } from 'gatsby'
import { useTheme } from '@emotion/react'
import classNames from 'classnames'
import CardContext from 'context/card'
import useGetImgPlacements from './useGetImgPlacements'
import useImgOptions from './useImgOptions'
import Image, { imgSizes } from './image'
import Body from './body'
import Badges from './badges'

export default function Card(props) {
    const {
        debug,
        attributes,
        product,
        url,
        image,
        imgOptions,
        linearGradient,
        cover,
        contain,
        background,
        onClick,
    } = props
    
    const theme = useTheme()
    const [isHovered, setIsHovered] = useState(false)
    const onMouseEnter = () => setIsHovered(true)
    const onMouseLeave = () => setIsHovered(false)

    const [imgSize, setImageSize] = useState(props?.imgSize)
    const [objectFit, setObjectFit] = useState(cover ? 'cover' : contain ? 'contain' : '')
    const [imgPlacement, setImagePlacement] = useState(background ? 'background' : 'top')
    
    const imgPlacements = useGetImgPlacements(imgPlacement)
    const { imgBackground, imgLeft, imgRight, imgBottom } = imgPlacements
    useImgOptions({ imgOptions, setImageSize, setObjectFit, setImagePlacement })

    const href = product ? product?.url : url ? url : '#'

    const style = {
        ...props.style,
        borderRadius: 12,
        color: imgBackground ? 'white' : theme.colors.black,
        background: imgBackground ? `${linearGradient ? linearGradient + ', ' : ''}url(${image}) lightgray center / cover no-repeat` : 'white',
        flexDirection: imgLeft ? 'row' : imgRight ? 'row-reverse' : imgBottom ? 'column-reverse' : 'column',
    }

    if (imgBackground && imgSize) {
        style.height = imgSizes[imgSize]
    }
    
    const className = classNames(
        props?.className,
        attributes?.className,
        'card scale t-200 td-0'
    )

    const value = {
        ...props,
        ...imgPlacements,
        isHovered,
        imgSize,
        objectFit,
    }

    const elementProps = {
        style,
        className,
        onMouseEnter,
        onMouseLeave,
        onClick,
    }
    
    const Element = href.startsWith('http') ? 'a' : Link
    if(Element === Link) elementProps.to = href
    if(Element === 'a') {
        elementProps.href = href
        elementProps.target = '_blank'
        elementProps.rel = 'noreferrer'
    }

    if (debug) console.log(props)
    // console.log(props)
    // console.log(value)
    // console.log(Element)

    return (
        <CardContext.Provider value={value}>
            <Element {...elementProps}>
                <Image />
                <Body />
                <Badges />
            </Element>
        </CardContext.Provider>
    )
}
